import { useTranslations } from '@northladder/i18n';

import { PublicFooter } from '../../app-footers';
import { AppHeader } from '../../app-headers';

import { PageNotFound } from './PageNotFound';

/**
 * -----------------------------------------------------------------------------
 * Renders a the basic structure of the Not Found 404 view.
 * This is used to display a custom 404 page for the app in case when the user
 * tries to access an invalid route that does not exist.
 */
export function NotFound404View() {
  const t = useTranslations('Error.pageNotFound');

  const ctaText = t('ctaText');
  const subtitle = t('subtitle');
  const title = t('title');
  return (
    <>
      <div className="flex min-h-screen flex-col overflow-hidden">
        <AppHeader />

        <div className="flex min-h-[calc(100vh-15rem)] flex-col justify-center">
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div
              className="
                shadow-xs bg-white px-4 py-8 dark:bg-gray-900/50
                sm:rounded-3xl sm:px-10
              "
            >
              <PageNotFound
                ctaText={ctaText}
                subtitle={subtitle}
                title={title}
              />
            </div>
          </div>
        </div>
      </div>
      <PublicFooter showFooterNav={false} />
    </>
  );
}
